import ajax from './ajax.js';
import dialog from './dialog.js';
import common from './common.js';

export default Object.assign({}, ajax, dialog, common);



// WEBPACK FOOTER //
// ./src/tools/index.js